import React from 'react';
import {
  FormPageAdditionalContent,
  FormPageAdditionalContentProps,
} from '../FormPageAdditionalContent';

export interface EntityPageAdditionalContentProps
  extends FormPageAdditionalContentProps {}

export function EntityPageAdditionalContent(
  props: EntityPageAdditionalContentProps,
) {
  return <FormPageAdditionalContent {...props} />;
}

EntityPageAdditionalContent.displayName = 'EntityPageAdditionalContent';
